import React, { useState, useEffect } from "react";
import NavBar, { infoUtente, loadNav } from "../../visualComponents/NavBarManager.js";
import { ArrowUpAZ, ArrowDownAZ } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Loader from "../../visualComponents/Loader.js";
import Tooltip from "../../components/Tooltip.js";

let isLoading = false;

const TableRow = ({ data }) => {
    return (
        <div className="grid grid-cols-9 gap-4 mt-2">
            <div></div>
            <div className="col-span-7 bg-gray-300 dark:bg-gray-500 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-7 p-4 text-center break-words">
                <div>{data.Data}</div>
                <div>{data.Utente}</div>
                <div>{data.Azienda}</div>
                <div>{data.CodiceComponente === "" ? ("-----") : (data.CodiceComponente)}</div>
                <div>{data.Descrizione}</div>
                <div>{data.OperazioneEseguita}</div>
                <div>{data.StatoAssunto}</div>
            </div>
            <div className="flex items-center">
            </div>
        </div>
    );
};

const LogManager = () => {
    const [indexTabella, setIndexTabella] = useState([
        { value: "Data", dbCode: "Data", ascending: true, filter: "text" },
        { value: "Utente", dbCode: "Utente", ascending: true, filter: "text" },
        { value: "Cliente", dbCode: "Azienda", ascending: true, filter: "text" },
        { value: "Componente", dbCode: "CodiceComponente", ascending: true, filter: "text" },
        { value: "Descrizione", dbCode: "Descrizione", ascending: true, filter: "text" },
        { value: "Operazione", dbCode: "OperazioneEseguita", ascending: true, filter: "text" },
        { value: "Stato", dbCode: "StatoAssunto", ascending: true, filter: "text" }
    ]);
    const [filters, setFilters] = useState({
        Data: "",
        Utente: "",
        Azienda: "",
        CodiceComponente: "",
        Descrizione: "",
        OperazioneEseguita: "",
        StatoAssunto: ""
    });
    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setViewData(data);
    }, [data]);

    useEffect(() => {
        let newData = [...data];
        for (const key in filters) {
            if (filters[key] !== "") {
                newData = newData.filter((d) => (d.value[key].toString().toLowerCase().includes(filters[key].toLowerCase())));
            }
        };
        setViewData(newData);
    }, [filters]);

    const onload = async () => {
        //getInfoUtente
        try {
            isLoading = true;

            await loadNav();

            //loadDati
            const r2 = await fetch('/getLog', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio
                })
            });
            const rd2 = await r2.json();
            if (r2.status === 500) {
                alert(rd2.error);
                console.log(rd2.error);
                navigate('/dashManager');
            } else {
                isLoading = false;
                setData(rd2.map(item => ({ value: item })));
            }

        } catch (error) {
            alert("Errore nel caricamento della pagina, riprovare più tardi");
            console.log(error);
            navigate('/dashManager');
        }
    };

    const sortByColumn = (column) => {
        setIndexTabella((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabella.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewData];

        newData.sort((a, b) => {
            const valA = a.value[column];
            const valB = b.value[column];

            const isDateFormat = typeof valA === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(valA);

            if (isDateFormat) {
                const dateA = parseDate(valA);
                const dateB = parseDate(valB);
                return isAscending ? dateA - dateB : dateB - dateA;
            }

            if (valA > valB) return isAscending ? -1 : 1;
            if (valA < valB) return isAscending ? 1 : -1;
            return 0;
        });

        setViewData(newData);
    };

    const parseDate = (str) => {
        const [day, month, year] = str.split('/');
        return new Date(`${year}-${month}-${day}`);
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page={"LOG"} />
            {isLoading && <Loader />}
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white p-4">
                <div className="grid grid-cols-9 gap-4 mt-14">
                    <div></div>
                    <div className="col-span-7 bg-gray-400 dark:bg-gray-600 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-7 p-4 font-bold text-center">
                        {
                            indexTabella.map((d, index) => (
                                <div key={index} onClick={() => sortByColumn(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 md:flex md:items-center md:justify-center">
                                    <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                    <Tooltip content="Ordina">
                                        <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                            {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                        </button>
                                    </Tooltip>
                                </div>
                            ))
                        }
                    </div>
                    <div></div>
                </div>
                <div className="grid grid-cols-9 gap-4 mt-2">
                    <div></div>
                    <div className="col-span-7 rounded-lg grid grid-cols-7 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                        {
                            indexTabella.map((d, index) => (
                                <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 6 ? "pl-2" : "px-2"}`}>
                                    <input
                                        type={d.filter}
                                        placeholder={d.value}
                                        value={filters[d.dbCode]}
                                        className="text-[2vw] md:text-base rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                        onChange={(e) => setFilters({ ...filters, [d.dbCode]: e.target.value })}
                                    />
                                </div>
                            ))
                        }
                    </div>
                    <div></div>
                </div>
                {viewData.map((data, index) => (
                    <TableRow key={index} data={data.value} />
                ))}
            </div>
        </div>
    );
};

export default LogManager;